// import logo from './logo.svg';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import './App.css';
import "./portfolio.css"
import About from "./About"
import Experience from "./Experience"
import Education from "./Education"
import Project from "./Projects"

function App() {
    const [section, setSection] = useState("home")
    const [mobile, setMobile] = useState(false)

    useEffect(() => {
        // if(window.innerWidth > 950){
        //     setMobile(false);
        // }
    }, [])

    return (

        <div>
            {/* ======= Header ======= */}
            <header id="header" className={`${section != "home" ? "header-top" : ""}`}>
                <div className="container">
                    <h1><Link to={"javascript:;"} onClick={() => (setSection("home"), setMobile(false))}>Mukesh Singh</Link></h1>
                    <h2>I'm a passionate <span> Sr. Full Stack Developer </span> from Chandigarh, India</h2>
                    <h2 className="subtitle"> ReactJS, NextJS, NodeJS, TypeScript, MongoDB, MySQL, Redis, AWS </h2>
                    <nav id="navbar" className={`navbar ${mobile ? "navbar-mobile" : ""}`}>
                        <ul>
                            {/* <li><a className="nav-link active" href="#header">Home</a></li> */}
                            <li><Link className={`nav-link ${section == "home" ? "active" : ""}`} to={"javascript:;"} onClick={() => (setSection("home"), setMobile(false))}>Home</Link></li>
                            <li><Link className={`nav-link ${section == "about" ? "active" : ""}`} to={"javascript:;"} onClick={() => (setSection("about"), setMobile(false))}>About</Link></li>
                            <li><Link className={`nav-link ${section == "experience" ? "active" : ""}`} to={"javascript:;"} onClick={() => (setSection("experience"), setMobile(false))}>Experience</Link></li>
                            <li><Link className={`nav-link ${section == "education" ? "active" : ""}`} to={"javascript:;"} onClick={() => (setSection("education"), setMobile(false))}>Education</Link></li>
                            <li><Link className={`nav-link ${section == "projects" ? "active" : ""}`} to={"javascript:;"} onClick={() => (setSection("projects"), setMobile(false))}>Projects</Link></li>

                        </ul>
                        <i className="bi bi-list mobile-nav-toggle" onClick={() => setMobile(!mobile)} />
                    </nav>{/* .navbar */}
                    <div className="social-links">
                        <a href="mailto:mukeshsingh9862@gmail.com" className="home-icon" target="_blank" rel="noreferrer"><i className="mdi mdi-gmail" /></a>
                        <a href="https://github.com/mukeshsingh9862" className="home-icon" target="_blank" rel="noreferrer"><i className="mdi mdi-github" /></a>
                        <a href="https://www.linkedin.com/in/mukesh-singh-9b087217a" className="home-icon" target="_blank" rel="noreferrer"><i className="mdi mdi-linkedin" /></a>
                    </div>
                </div>
            </header>{/* End Header */}

            <About section={section} setSection={setSection} />
            <Experience section={section} setSection={setSection} />
            <Education section={section} setSection={setSection} />
            <Project section={section} setSection={setSection} />

        </div>

    );
}

export default App;
